jQuery(function ($) {
	const Scripts = {

		varInit() {
			this.body = $('body');
			this.header = $('header');
			this.footer = $('footer');
			this.document = $(document);
		},

		debounce: function(func, wait, immediate) {
			let timeout;
			return function executedFunction() {
				const context = this;
				const args = arguments;
				const later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				const callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},

		scrollToAnchor() {
			// Перехоплення кліків за посиланнями з data-target
			$('a.scroll-to').on('click', function(e){
				const target = $(this).data('target');
				if (target) {
					sessionStorage.setItem('scrollTarget', target);
				}
			});

			// Після завантаження сторінки - перевірка і плавний скрол
			const hash = sessionStorage.getItem('scrollTarget');
			if (hash) {
				const target = $(hash);
				if (target.length) {
					sessionStorage.removeItem('scrollTarget'); // очищаємо
					// Трохи відкладемо скрол, щоб усе встигло відрендеритися
					setTimeout(function() {
						$('html, body').animate({
							scrollTop: target.offset().top
						}, 600);
					}, 10);
				}
			}
		},

		headerScripts() {
			const ctrl = this;

			const menuBtn = $('#menu-toggle');
			const menu = $('#main-menu');
			const labelOpen = menuBtn.find('.header-menu-sr-label--open');
			const labelClose = menuBtn.find('.header-menu-sr-label--close');

			const searchBtn = $('#search-btn');
			const searchPopup = $('#search-popup');
			const searchCloseBtn = $('#search-close-btn');

			menuBtn.on('click', function () {
				const isExpanded = menuBtn.attr('aria-expanded') === 'true';

				if (!isExpanded) {
					if (ctrl.body.hasClass('search-open')) closeSearch();

					$('html, body').stop(true).animate({ scrollTop: 0 }, 300);

					lockScroll();
					openMenu();
				} else {
					closeMenu();
				}
			});

			searchBtn.on('click', function () {
				const isSearchOpen = ctrl.body.hasClass('search-open');

				if (!isSearchOpen) {
					if (ctrl.body.hasClass('menu-open')) closeMenu();

					$('html, body').stop(true).animate({ scrollTop: 0 }, 300);

					lockScroll();
					openSearch();
				} else {
					closeSearch();
				}
			});

			searchCloseBtn.on('click', function () {
				closeSearch();
			});

			// Клік поза меню і пошуку
			ctrl.document.on('click', function (e) {
				if (ctrl.body.hasClass('menu-open')) {
					if (!$(e.target).closest(menu).length && !$(e.target).closest(menuBtn).length) {
						closeMenu();
					}
				}
				if (ctrl.body.hasClass('search-open')) {
					if (!$(e.target).closest(searchPopup).length && !$(e.target).closest(searchBtn).length && !$(e.target).closest(searchCloseBtn).length) {
						closeSearch();
					}
				}
			});

			function lockScroll() {
				const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
				ctrl.body.css({
					overflow: 'hidden',
					'padding-right': scrollBarWidth + 'px'
				});
			}

			function unlockScroll() {
				ctrl.body.css({
					overflow: '',
					'padding-right': ''
				});
			}

			function openMenu() {
				ctrl.body.addClass('menu-open');
				menuBtn.attr('aria-expanded', 'true');
				menuBtn.addClass('is-open');
				menu.addClass('is-open');
				labelOpen.attr('aria-hidden', 'true');
				labelClose.attr('aria-hidden', 'false');
			}

			function closeMenu() {
				ctrl.body.removeClass('menu-open');
				menuBtn.attr('aria-expanded', 'false');
				menuBtn.removeClass('is-open');
				menu.removeClass('is-open');
				labelOpen.attr('aria-hidden', 'false');
				labelClose.attr('aria-hidden', 'true');

				if (!ctrl.body.hasClass('search-open')) {
					unlockScroll();
				}
			}

			function openSearch() {
				ctrl.body.addClass('search-open');
				searchBtn.attr('aria-expanded', 'true');
				searchPopup.attr('aria-hidden', 'false').addClass('is-open');
			}

			function closeSearch() {
				// Спочатку прибрати фокус, щоб він не залишився в прихованому блоці
				if (document.activeElement && searchPopup.has(document.activeElement).length) {
					searchBtn.trigger('focus'); // повернути фокус на кнопку відкриття
				}

				ctrl.body.removeClass('search-open');
				searchBtn.attr('aria-expanded', 'false');
				searchPopup.attr('aria-hidden', 'true').removeClass('is-open');

				if (!ctrl.body.hasClass('menu-open')) {
					unlockScroll();
				}
			}
		
		},

		searchReset() {
			let searchInput = $('.search-input');
			searchInput.each(function() {
				let thisInput = $(this);
				let searchReset = thisInput.siblings('.search-reset');
				if (thisInput.length) {
					if (thisInput.val() != '') {
						searchReset.addClass('show');
					}
					thisInput.keyup( function() {
						if (thisInput.val() != '') {
							searchReset.addClass('show');
						} else {
							searchReset.removeClass('show');
						}
					});
				}
				searchReset.click(function(){
					thisInput.val('');
					thisInput.focus();
					searchReset.removeClass('show');
				});
			});
		},

		svgMapScripts: function() {
			// Отримуємо елемент підказки
			let tooltip = $('.home-map__tooltip');
			// Зберігаємо останню назву регіону, щоб уникнути зайвих оновлень DOM
			let lastRegionTitle = '';

			// Вішаємо обробники подій на елементи регіонів карти
			$('#ua-map .ua-map__region')
			.on('mouseenter', function () {
				// Отримуємо назву регіону з data-атрибута
				let title = $(this).data("region-title");
				// Якщо назва інша, оновлюємо вміст підказки
				if (lastRegionTitle !== title) {
					tooltip.html(title);
					lastRegionTitle = title;
				}
			})
			.on('mousemove', function (e) {
				// Отримуємо координати батьківського елемента (для позиціонування)
				let parentOffset = $(this).parent().offset();

				// Вираховуємо координати курсора відносно батьківського елемента
				let relX = e.pageX - parentOffset.left;
				let relY = e.pageY - parentOffset.top - 70;

				// Визначаємо позицію по горизонталі (щоб не вилітала за межі)
				let left = relX - tooltip.innerWidth() / 2;
				if (relX > $(this).parent().width() - 100) {
					left = relX - tooltip.innerWidth(); // Якщо майже правий край — підказка лівіше
				} else if (relX < 100) {
					left = relX; // Якщо майже лівий край — підказка правіше
				}

				// Встановлюємо позицію та показуємо підказку
				tooltip.css({ left: left + 'px', top: relY + 'px', opacity: 1 });
			})
			.on('mouseleave', function () {
				// Ховаємо підказку при виході курсора за межі регіону
				tooltip.css({ left: 0, top: 0, opacity: 0 });
				// tooltip.html('');
				// Скидаємо останню назву, щоб при наступному вході знову оновився текст
				lastRegionTitle = '';
			});

			$('.ua-map__region').click(function() {
				let reg_slug = $(this).data("region");

				// 1) Беремо поточні параметри з URL
				const params = new URLSearchParams(window.location.search);

				// 2) Пропускаємо тільки ті, що відносяться до фільтрів карти
				const allowedKeys = ['subordination', 'type', 'visit', 'date_from', 'date_to'];
				const out = new URLSearchParams();

				allowedKeys.forEach((key) => {
					if (params.has(key) && params.get(key) !== '') {
						out.set(key, params.get(key));
					}
				});

				// 3) Збираємо посилання на регіон + query
				const qs = out.toString();
				const url = window.location.origin + '/region/' + reg_slug + '/' + (qs ? ('?' + qs) : '');

				location.assign(url);
			});

		},

		lazyInitSvgMap() {
			let inited = false;

			function tryInit() {
				if (window.innerWidth >= 1260 && !inited) {
					Scripts.svgMapScripts();
					inited = true;
				}
			}

			tryInit();
			$(window).on('resize', tryInit);
		},
		
		googleMapInit() {
			// швидкий вихід, якщо немає координат/ID карти
			if (
				typeof regionCoordinates !== 'object' ||
				!regionCoordinates.lat || !regionCoordinates.lng || !regionCoordinates.mapId
			) return;

			let attempts = 0;
			const MAX_ATTEMPTS = 50;
			const MAP_ZOOM_MAX = 18;

			const waitForReady = setInterval(async function () {
				attempts++;

				const hasAPI = !!(window.google?.maps?.importLibrary);
				const el = document.getElementById('map');
				if (!hasAPI || !(el instanceof HTMLElement)) {
					if (attempts >= MAX_ATTEMPTS) clearInterval(waitForReady);
					return;
				}
				if (el.dataset.mapInited === '1') {
					clearInterval(waitForReady);
					return;
				}

				clearInterval(waitForReady);

				// не затіняємо ES6 Map
				const { Map: GMap } = await google.maps.importLibrary('maps');
				await google.maps.importLibrary('marker');

				const map = new GMap(el, {
					center: { lat: parseFloat(regionCoordinates.lat), lng: parseFloat(regionCoordinates.lng) },
					zoom: 4,
					disableDefaultUI: true,
					mapId: regionCoordinates.mapId,
					clickableIcons: false,
					maxZoom: MAP_ZOOM_MAX
				});
				el.dataset.mapInited = '1';

				// ---- інфо-сутності (один раз) ----
				const info = new google.maps.InfoWindow();
				const infoPanelEl = document.getElementById('map-info'); // може бути null — ок
				const mq = window.matchMedia('(max-width: 1259px)');

				function closeAllInfo() {
					info.close();
					if (infoPanelEl) {
						infoPanelEl.classList.remove('open');
						infoPanelEl.innerHTML = '';
					}
				}

				// слухачі — ОДИН раз
				if (!map.__npm_infoListenersBound) {
					// клік по карті = закрити інфо
					map.addListener('click', closeAllInfo);

					// зміна брейкпоінта = закрити поточний вид інфо
					if (mq.addEventListener) {
						mq.addEventListener('change', closeAllInfo);
					} else if (mq.addListener) { // старі браузери
						mq.addListener(closeAllInfo);
					}
					map.__npm_infoListenersBound = true;
				}

				// ---- дані ----
				const boot = Array.isArray(window.__GMAP_BOOT__?.markers)
					? window.__GMAP_BOOT__.markers
					: [];

				// ---- групування однакових координат ----
				function groupByCoords(items, precision = 6) {
					const dict = new Map();
					for (const r of items) {
						const key = `${(+r.lat).toFixed(precision)}|${(+r.lng).toFixed(precision)}`;
						let g = dict.get(key);
						if (!g) {
							g = { lat: +r.lat, lng: +r.lng, posts: 0, visits: 0, violations: 0, items: [] };
							dict.set(key, g);
						}
						g.posts += 1;
						g.visits += (r.visits || 0);
						g.violations += (r.violations || 0);
						g.items.push(r);
					}
					return Array.from(dict.values());
				}
				const groups = groupByCoords(boot);

				// ---- контент маркерів ----
				function createSingleMarkerContent(visits, violations, title) {
					const wrap = document.createElement('div');
					wrap.className = 'region-map-marker';

					const badgesWrap = document.createElement('div');
					badgesWrap.className = 'region-map-marker__badges-wrap';

					const b1 = document.createElement('div');
					b1.className = 'region-map-marker__badge region-map-marker__badge--vis';
					b1.textContent = String(visits);

					const b2 = document.createElement('div');
					b2.className = 'region-map-marker__badge region-map-marker__badge--vio';
					b2.textContent = String(violations);

					badgesWrap.append(b1, b2);

					const dot = document.createElement('div');
					dot.className = 'npm-pin-dot';

					wrap.append(badgesWrap, dot);
					return wrap;
				}
				function createGroupMarkerContent(group) {
					const wrap = document.createElement('div');
					wrap.className = 'region-map-marker region-map-marker--group';

					const badgesWrap = document.createElement('div');
					badgesWrap.className = 'region-map-marker__badges-wrap';

					const c1 = document.createElement('div');
					c1.className = 'region-map-marker__badge region-map-marker__badge--plc';
					c1.textContent = String(group.posts);

					const c2 = document.createElement('div');
					c2.className = 'region-map-marker__badge region-map-marker__badge--vis';
					c2.textContent = String(group.visits);

					const c3 = document.createElement('div');
					c3.className = 'region-map-marker__badge region-map-marker__badge--vio';
					c3.textContent = String(group.violations);

					badgesWrap.append(c1, c2, c3);

					const dot = document.createElement('div');
					dot.className = 'npm-pin-dot';

					wrap.append(badgesWrap, dot);
					return wrap;
				}

				// ---- єдиний HTML інфо-блока ----
				function escapeHtml(s) {
					return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
						.replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
				}
				function buildInfoHtml(group) {
					let html = '<div class="npm-infowindow">';
					for (const it of group.items) {
						html += `<div class="npm-iw-item">
							<div class="npm-iw-title">${escapeHtml(it.title)}</div>
							<div class="npm-iw-actions">
								<a href="${it.permalink}">
									${localizeTexts.more}
									<svg aria-hidden="true" class="icon">
										<use href="${localizeTexts.spritePath}#arrow"></use>
									</svg>
								</a>
							</div>
						</div>`;
					}
					html += '</div>';
					return html;
				}

				// ---- створюємо маркери ----
				const advMarkers = [];
				const bounds = new google.maps.LatLngBounds();

				groups.forEach(g => {
					const content = (g.posts === 1)
						? createSingleMarkerContent(g.visits, g.violations, g.items[0].title)
						: createGroupMarkerContent(g);

					const adv = new google.maps.marker.AdvancedMarkerElement({
						map,
						position: { lat: g.lat, lng: g.lng },
						content,
						zIndex: 10,
						title: (g.posts === 1 ? g.items[0].title : `x${g.posts} об'єктів`)
					});

					// зберігаємо агрегати для кластера (пости/візити/порушення)
					adv.npmData = { posts: g.posts, visits: g.visits, violations: g.violations };

					// клік по маркеру → показуємо блок у потрібному місці
					adv.addListener('gmp-click', () => {
						const html = buildInfoHtml(g);

						if (mq.matches && infoPanelEl) {
							// моб. брейкпоінт: зовнішній блок під картою
							info.close();
							infoPanelEl.innerHTML = `<div class="map-info__card">${html}</div>`;
							infoPanelEl.classList.add('open');
						} else {
							// десктоп: InfoWindow
							if (infoPanelEl) {
								infoPanelEl.classList.remove('open');
								infoPanelEl.innerHTML = '';
							}
							info.setContent(html);
							info.setPosition({ lat: g.lat, lng: g.lng });
							info.open({ map });
						}
					});

					advMarkers.push(adv);
					bounds.extend({ lat: g.lat, lng: g.lng });
				});

				const { MarkerClusterer, SuperClusterAlgorithm } = markerClusterer;

				// ---- fitBounds з обмеженням зума ----
				function fitBoundsCapped(bounds) {
					if (!bounds || bounds.isEmpty()) return;

					map.fitBounds(bounds);

					// після fitBounds може виставитися зум > MAP_ZOOM_MAX → обмежуємо
					google.maps.event.addListenerOnce(map, 'idle', () => {
						const z = Number(map.getZoom() || 0);
						if (z > MAP_ZOOM_MAX) {
							map.setZoom(MAP_ZOOM_MAX);
						}
						// після корекції одразу синхронізуємо кластер/точки
						syncModeByZoom();
					});
				}

				const DEFAULT_REGION_ZOOM = 7;

				function focusRegionDefault() {
					map.setCenter({
						lat: parseFloat(regionCoordinates.lat),
						lng: parseFloat(regionCoordinates.lng)
					});
					map.setZoom(DEFAULT_REGION_ZOOM);
				}

				if (!bounds.isEmpty()) {
					fitBoundsCapped(bounds);
				} else {
				// старт без маркерів: просто покажемо регіон
					focusRegionDefault();
				}

				if (bounds.isEmpty()) {
					map.setCenter({ lat: parseFloat(regionCoordinates.lat), lng: parseFloat(regionCoordinates.lng) });
					map.setZoom(7);
				}

				// =========================================================
				// КАСТОМНИЙ РЕНДЕРЕР КЛАСТЕРІВ
				// Малюємо власний пін кластера (AdvancedMarkerElement),
				// а число всередині = сума posts із усіх маркерів кластера.
				// =========================================================

				const postsSumRenderer = {
					/**
					 * @param {import('@googlemaps/markerclusterer').Cluster} cluster
					 * @param {import('@googlemaps/markerclusterer').ClusterStats} stats
					 * @param {google.maps.Map} map
					 * @returns {google.maps.marker.AdvancedMarkerElement}
					 */
					render(cluster, stats, map) {
						// 1) Рахуємо суму постів у кластері (fallback: якщо немає npmData.posts — рахуємо як 1)
						const totalPosts = cluster.markers.reduce((sum, m) => {
							const p = (m && m.npmData && Number(m.npmData.posts)) || 1;
							return sum + p;
						}, 0);

						// 2) Готуємо HTML піна кластера (мінімальна семантика, далі стилізуємо CSS)
						const el = document.createElement('div');
						el.className = 'npm-cluster';
						el.innerHTML = `
							<div class="npm-cluster__inner">
								<span class="npm-cluster__count">${String(totalPosts)}</span>
							</div>
						`;

						// 3) Повертаємо AdvancedMarkerElement замість дефолтного
						const adv = new google.maps.marker.AdvancedMarkerElement({
							position: cluster.position,
							content: el,
							zIndex: 100 + Math.min(totalPosts, 999) // трохи піднімаємо над звичайними пінами
						});

						return adv;
					}
				};

				// 1) Готуємо кластеризатор (поведінку maxZoom не використовуємо — керуємо самі)
				const clusterer = new markerClusterer.MarkerClusterer({
					map: null, // поки вимкнений — вмикаємо вручну нижче
					markers: [], // додамо під час увімкнення
					renderer: postsSumRenderer, // кастомний renderer (сума постів)
					algorithm: new markerClusterer.SuperClusterAlgorithm({
						// maxZoom ставимо великим, щоб не заважав нашій ручній логіці
						maxZoom: 25
					})
				});

				// --- ЖОРСТКИЙ ПЕРЕМИКАЧ ЗА ЗУМОМ ---
				const SWITCH_ZOOM = 13;

				// Увімкнути режим «кластер» (кластер УВІМКН., точки ВИКЛ.)
				function enableClusterMode() {
					if (map.__npm_clusterOn) return;
					// знімаємо маркери з карти, щоб не дублювалися з кластером
					for (const adv of advMarkers) if (adv.map) adv.map = null;
					clusterer.clearMarkers();
					clusterer.addMarkers(advMarkers);
					clusterer.setMap(map);
					// точки сховати
					for (const adv of advMarkers) adv.content?.classList.remove('has-dot');
					map.__npm_clusterOn = true;
				}

				// Увімкнути режим «точки» (кластер ВИМКН., точки УВІМКН.)
				function disableClusterMode() {
					// відв’язуємо кластер
					clusterer.clearMarkers();
					clusterer.setMap(null);

					// гарантуємо, що всі маркери на мапі
					for (const adv of advMarkers) {
						if (!adv.map) adv.map = map;
					}

					// додаємо чорну точку
					for (const adv of advMarkers) {
						adv.content?.classList.add('has-dot');
					}

					map.__npm_clusterOn = false;
				}

				// Синхронізація режиму відповідно до поточного зума
				function syncModeByZoom() {
					const z = Number(map.getZoom() || 0);
					if (z >= SWITCH_ZOOM) {
						disableClusterMode(); // кластер ВИМКН., точки УВІМКН.
					} else {
						enableClusterMode(); // кластер УВІМКН., точки ВИКЛ.
					}
				}

				// Надійний старт:
				// а) одразу за поточним зумом
				// б) ще раз після стабілізації карти (idle після fitBounds/анімації)
				syncModeByZoom();
				google.maps.event.addListenerOnce(map, 'idle', syncModeByZoom);

				// Подальші зміни зума — перемикаємо режим після завершення анімації
				map.addListener('zoom_changed', () => {
					google.maps.event.addListenerOnce(map, 'idle', syncModeByZoom);
				});

				// =========================================================
				// ОНОВЛЕННЯ МАРКЕРІВ ДЛЯ AJAX-ФІЛЬТРІВ (region-map)
				// Викликається ззовні як window.__REGION_GMAP__.updateMarkers(newMarkers)
				// =========================================================
				function rebuildMarkersFromBootData(markers) {
					// 1) закрити інфо
					closeAllInfo();

					// 2) зняти старі маркери з карти
					for (const adv of advMarkers) {
						if (adv) adv.map = null;
					}
					advMarkers.length = 0;

					// 3) прибрати/очистити кластер, але не ламати наш режим
					clusterer.clearMarkers();
					clusterer.setMap(null);
					map.__npm_clusterOn = false;

					// 4) згрупувати за координатами (як при першій ініціалізації)
					const groups = groupByCoords(markers);

					// 5) створити нові маркери
					const newBounds = new google.maps.LatLngBounds();
					groups.forEach(g => {
						const content = (g.posts === 1)
							? createSingleMarkerContent(g.visits, g.violations, g.items[0].title)
							: createGroupMarkerContent(g);

						const adv = new google.maps.marker.AdvancedMarkerElement({
							map, // тимчасово виводимо напряму — режим визначить sync нижче
							position: { lat: g.lat, lng: g.lng },
							content,
							zIndex: 10,
							title: (g.posts === 1 ? g.items[0].title : `x${g.posts} об'єктів`)
						});

						adv.npmData = { posts: g.posts, visits: g.visits, violations: g.violations };

						// клік → показ інфо (той самий, що і вище)
						adv.addListener('gmp-click', () => {
							const html = buildInfoHtml(g);
							if (mq.matches && infoPanelEl) {
								info.close();
								infoPanelEl.innerHTML = `<div class="map-info__card">${html}</div>`;
								infoPanelEl.classList.add('open');
							} else {
								if (infoPanelEl) {
									infoPanelEl.classList.remove('open');
									infoPanelEl.innerHTML = '';
								}
								info.setContent(html);
								info.setPosition({ lat: g.lat, lng: g.lng });
								info.open({ map });
							}
						});

						advMarkers.push(adv);
						newBounds.extend({ lat: g.lat, lng: g.lng });
					});

					if (advMarkers.length === 0) {
						closeAllInfo();
						focusRegionDefault();
						disableClusterMode();
						return;
					}

					if (!newBounds.isEmpty()) {
						// підлаштуємо карту під нові маркери
						fitBoundsCapped(newBounds);

						// 1) Миттєва синхронізація — спрацює, навіть якщо карта НЕ змінилася
						syncModeByZoom();

						// 2) Повторна синхронізація після завершення будь-яких рухів карти (якщо вони були)
						google.maps.event.addListenerOnce(map, 'idle', syncModeByZoom);
					} else {
						// маркерів немає → просто приводимо режим у відповідність до поточного масштабу
						syncModeByZoom();
					}

				}

				// Експортуємо «API» для зовнішнього виклику з фільтрів
				window.__REGION_GMAP__ = {
					/**
					 * Оновити маркери: приймає масив у форматі npm_get_region_markers(...)
					 * @param {Array<{id:number,title:string,permalink:string,lat:number,lng:number,visits:number,violations:number}>} newMarkers
					 */
					updateMarkers(newMarkers) {
						if (!Array.isArray(newMarkers)) return;
						rebuildMarkersFromBootData(newMarkers);
					},
					// для зручності — викличемо режимну синхронізацію вручну
					sync: () => syncModeByZoom()
				};

			}, 100);
		},

		// Відкриває / закриває загальну панель фільтрів
		filtersToggle() {
			const wrap = $('.filters-section__wrap');
			const toggle = $('#filter-toggle');
			const panel = $('#filter-panel');
			const opacitySection = $('.filter-section-opacity');

			toggle.on('click', function () {
				const isOpen = panel.is(':visible');

				if (isOpen) {
					panel.slideUp(300);
					toggle.attr('aria-expanded', 'false');
					wrap.removeClass('is-open');
					opacitySection.removeClass('opacity-section');
				} else {
					panel.slideDown(300);
					toggle.attr('aria-expanded', 'true');
					wrap.addClass('is-open');
					opacitySection.addClass('opacity-section');
				}
			});

			// Клік поза панеллю — закриває її
			$(document).on('click', function (e) {
				if ($(e.target).closest('#air-datepicker-global-container').length > 0) {
					return;
				}

				if (
					!panel.is(e.target) &&
					panel.has(e.target).length === 0 &&
					!toggle.is(e.target) &&
					toggle.has(e.target).length === 0 &&
					panel.is(':visible')
				) {
					Scripts.__closeFiltersPanel();
				}
			});

			// Закриття панелі клавішею Escape
			$(document).on('keydown', function (e) {
				if (e.key === 'Escape' && panel.is(':visible')) {
					Scripts.__closeFiltersPanel();
				}
			});
		},

		__closeFiltersPanel() {
			const panel = $('#filter-panel');
			const toggle = $('#filter-toggle');
			const wrap = $('.filters-section__wrap');
			const opacitySection = $('.filter-section-opacity');

			if (panel.is(':visible')) {
				panel.slideUp(300);
				toggle.attr('aria-expanded', 'false');
				wrap.removeClass('is-open');
				opacitySection.removeClass('opacity-section');

				Scripts.__closeFilterDropdownsAndSearch();
			}
		},

		// Відкриває / закриває окремі фільтри-дропдауни
		filtersDropdownToggle() {
			const buttons = $('.filter-btn');

			buttons.on('click', function (e) {
				e.stopPropagation();
				const clicked = $(this);
				const targetId = clicked.attr('aria-controls');
				const targetList = $('#' + targetId);
				const isOpen = clicked.attr('aria-expanded') === 'true';

				// Закриваємо всі відкриті дропдауни
				Scripts.__closeFilterDropdownsAndSearch();

				// Якщо поточний був закритий - відкрити
				if (!isOpen) {
					buttons
					.filter(`[aria-controls="${targetId}"]`)
					.attr('aria-expanded', 'true')
					.addClass('is-open');
					targetList.slideDown(200).addClass('is-open');
				}
			});

			// Клік поза випадашками - закриває все
			$(document).on('click', function (e) {
				const target = $(e.target);

				const isClickOnButton = target.closest('.filter-btn').length > 0;
				const isClickOnPanel = target.closest('.filter-panel').length > 0;
				const isClickOnDatepickerContainer = target.closest('#air-datepicker-global-container').length > 0;

				if (!isClickOnButton && !isClickOnPanel && !isClickOnDatepickerContainer) {
					Scripts.__closeFilterDropdownsAndSearch();
				}
			});

			$(document).on('keydown', function (e) {
				if (e.key === 'Escape') {
					Scripts.__closeFilterDropdownsAndSearch();
				}
			});
		},

		// Закриває всі фільтри + очищає поля пошуку
		__closeFilterDropdownsAndSearch() {
			$('.filter-btn').attr('aria-expanded', 'false').removeClass('is-open');
			$('.filter__dropdown').slideUp(200).removeClass('is-open');

			$('.filter-dropdown-search__input').each(function () {
				const input = $(this);
				const reset = input.siblings('.search-reset');

				if (input.val()) {
					input.val('').trigger('input');
					reset.removeClass('show');
				}
			});
		},

		// Додає live-пошук по чекбоксам у кожному дропдауні
		filtersSearchInput() {
			$('.filter-dropdown-search__input').each(function () {
				const input = $(this);
				const dropdown = input.closest('.filter__dropdown');
				const reset = dropdown.find('.search-reset');
				const list = dropdown.find('.filter__list');
				const items = list.find('.filter__item');

				// Блокуємо Enter
				input.on('keydown', function (e) {
					if (e.key === 'Enter') {
						e.preventDefault();
					}
				});

				// Пошук за input
				input.on('input', Scripts.debounce(function () {
					const query = input.val().trim().toLowerCase();
					let hasResults = false;

					items.each(function () {
						const text = $(this).text().trim().toLowerCase();
						const match = text.includes(query);
						$(this).toggle(match);
						if (match) hasResults = true;
					});

					// Видаляємо попереднє повідомлення
					list.find('.filter__item--no-results').remove();

					// Додаємо повідомлення, якщо нічого не знайдено
					if (!hasResults) {
						list.append(`<label class="filter__item filter__item--no-results">${localizeTexts.noResults}</label>`);
					}
				}, 300));

				// Кнопка скидання
				reset.on('click keydown', function (e) {
					if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
						input.val('');
						input.trigger('input');
						input.focus();
					}
				});
			});
		},

		initDateRangePickerAir() {
			const localeUk = {
				days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'],
				daysShort: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
				months: ['Січень','Лютий','Березень','Квітень','Травень','Червень','Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'],
				monthsShort: ['Січ','Лют','Бер','Квіт','Трав','Черв','Лип','Серп','Вер','Жовт','Лист','Груд'],
				today: 'Сьогодні',
				clear: 'Очистити',
				dateFormat: 'dd.MM.yyyy',
				firstDay: 1
			};

			let dpFrom, dpTo;

			dpFrom = new AirDatepicker('#date-from', {
				locale: localeUk,
				dateFormat: 'dd.MM.yyyy',
				autoClose: true,
				onSelect({ date, datepicker }) {
					const input = $(datepicker.$el);

					if (date) {
						dpTo.update({
							minDate: date
						});
					} else if (input.val().trim() === '') {
						// Якщо дата була знята
						dpTo.update({
							minDate: false
						});
					}

					input.trigger('change');
				}
			});

			dpTo = new AirDatepicker('#date-to', {
				locale: localeUk,
				dateFormat: 'dd.MM.yyyy',
				autoClose: true,
				onSelect({ date, datepicker }) {
					const input = $(datepicker.$el);

					if (date) {
						dpFrom.update({
							maxDate: date
						});
					} else if (input.val().trim() === '') {
						// Якщо дата була знята
						dpFrom.update({
							maxDate: false
						});
					}

					input.trigger('change');
				}
			});

			function parseDateString(dateStr) {
				const parts = dateStr.split('.');
				if (parts.length !== 3) return null;

				const day = parseInt(parts[0], 10);
				const month = parseInt(parts[1], 10) - 1; // місяці в JS с 0
				const year = parseInt(parts[2], 10);

				return new Date(year, month, day);
			}

			const dateFromVal = $('#date-from').val();
			const dateToVal = $('#date-to').val();

			if (dateFromVal) {
				const parsedFrom = parseDateString(dateFromVal);
				if (parsedFrom) dpFrom.selectDate(parsedFrom);
			}

			if (dateToVal) {
				const parsedTo = parseDateString(dateToVal);
				if (parsedTo) dpTo.selectDate(parsedTo);
			}

			$('.filters-form').on('reset', function () {
				setTimeout(() => {
					dpFrom.clear();
					dpTo.clear();

					dpFrom.update({
						maxDate: false
					});
					dpTo.update({
						minDate: false
					});
				}, 0);
			});

		},

		initFilterStateTracking() {
			const filterToggle = $('#filter-toggle');
			const submitBtn = $('.filter-action-buttons__btn--submit');
			const resetBtn = $('.filter-action-buttons__btn--reset');
			const filterItems = $('.filters-form__item');

			function checkFiltersState() {
				let anyFilterActive = false;

				filterItems.each(function () {
					const item = $(this);
					const dropdown = item.find('.filter__dropdown');
					const dropdownId = dropdown.attr('id');

					const checkboxes = dropdown.find('input[type="checkbox"]');
					const radios = dropdown.find('input[type="radio"]');
					const dateInputs = dropdown.find('.filter__date-input');

					let isActive = false;

					if (checkboxes.length && checkboxes.is(':checked')) {
						isActive = true;
					}

					if (radios.length) {
						const checkedRadio = radios.filter(':checked');
						if (checkedRadio.length && checkedRadio.val() !== '') {
							isActive = true;
						}
					}

					dateInputs.each(function () {
						if ($(this).val().trim() !== '') {
							isActive = true;
						}
					});

					const controllingButtons = $(`.filter-btn[aria-controls="${dropdownId}"]`);
					controllingButtons.toggleClass('active', isActive);

					if (isActive) {
						anyFilterActive = true;
					}
				});

				// Поле пошуку (.filter-search-block) — окремо від filters-form__item
				const searchInput = $('.filter-search-block input[name="search"]');
				if (searchInput.length && searchInput.val().trim() !== '') {
					anyFilterActive = true;
				}

				filterToggle.toggleClass('active', anyFilterActive);

				submitBtn.prop('disabled', !anyFilterActive);
				// resetBtn.prop('disabled', !anyFilterActive);
			}

			$('.filters-form').on('change input', 'input', function () {
				checkFiltersState();
			});

			// checkFiltersState();

			$('.filters-form').on('reset', function () {
				setTimeout(() => {
					checkFiltersState();
				}, 0);
			});
		},

		initFilterAjaxHandling() {
			const form = $('.filters-form');

			form.on('submit', function (e) {
				e.preventDefault();

				const formEl = $(this);
				const postType = formEl.data('post-type') || '';
				const context = formEl.data('context') || ''; // 'archive' | 'svg-map'
				const postsPerPage = formEl.data('posts-per-page') || '';

				const formDataArray = formEl.serializeArray();
				const filters = {};
				const queryParts = [];

				formDataArray.forEach(({ name, value }) => {
					if (!value) return;

					const cleanName = name.replace(/\[\]$/, '');
					const $input = formEl.find(`[name="${name}"]`);

					if ($input.is(':checkbox') || $input.is('[multiple]')) {
						// чекбокси або мультиселект → масив
						if (!filters[cleanName]) filters[cleanName] = [];
						filters[cleanName].push(value);
					} else {
						// радіо або одиночний select/input → рядок
						filters[cleanName] = value;
					}
				});

				for (const [key, values] of Object.entries(filters)) {
					const val = Array.isArray(values) ? values.join(',') : values;
					queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
				}

				const queryString = queryParts.join('&');
				const queryStringWithQuestion = queryString ? `?${queryString}` : '';

				let l = '';
				if (lang != 'uk') {
					l = '/' + lang;
				}

				if (context === 'archive') {
					history.replaceState(null,'', l + '/' + postType + '/' + queryStringWithQuestion);

					const ajaxData = {
						action: 'filter_posts',
						post_type: postType,
						context: context,
						posts_per_page: postsPerPage,
						filters: filters,
						query_string: queryStringWithQuestion
					};

					$.ajax({
						url: ajaxurl,
						method: 'POST',
						dataType: 'json',
						data: ajaxData,
						success(response) {
							$('.filters-post-wrap').html(response.data.posts);
							$('.pagination').html(response.data.pagination);

							const hasActiveFilters = $('.filters-form').serializeArray().some(({ name, value }) => value && value.trim() !== '');
							$('.filter-action-buttons__btn--reset').prop('disabled', !hasActiveFilters);

							Scripts.__closeFiltersPanel();
						}
					});
				} else if (context === 'reports') {
 
					// URL сторінки звітів для пагінації (/reports/N/), з data-base-url форми
					const baseUrl = formEl.data('base-url') || '';
				 
					// Оновлюємо адресний рядок (фільтри в query string), сторінку скидаємо на 1
					history.replaceState(null, '', baseUrl + queryStringWithQuestion);
				 
					const ajaxData = {
						action: 'filter_reports',
						posts_per_page: postsPerPage,
						filters: filters,
						base_url: baseUrl
					};
				 
					$.ajax({
						url: ajaxurl,
						method: 'POST',
						dataType: 'json',
						data: ajaxData,
						success(response) {
							$('.filters-post-wrap').html(response.data.posts);
							$('.pagination').html(response.data.pagination);
				 
							const hasActiveFilters = $('.filters-form').serializeArray().some(({ name, value }) => value && value.trim() !== '');
							$('.filter-action-buttons__btn--reset').prop('disabled', !hasActiveFilters);
				 
							Scripts.__closeFiltersPanel();
						}
					});
				} else if (context === 'svg-map') {
					history.replaceState(null, '', l + '/' + queryStringWithQuestion);

					const ajaxData = {
						action: 'npm_map_stats',
						filters: filters,
						query_string: queryStringWithQuestion
					};

					$.ajax({
						url: ajaxurl,
						method: 'POST',
						dataType: 'json',
						data: ajaxData,
						success(resp) {
							if (!resp || !resp.success || !resp.regions) return;

							// --- оновлюємо маркери по регіонах ---
							const regions = resp.regions;
							$('.map-markers__region').each(function () {
								const regionEl = $(this);
								const slug = regionEl.data('region');
								const box = regions[slug];
								if (!box) return;

								regionEl.find('.map-markers__marker--places').text(box.places ?? 0);
								regionEl.find('.map-markers__marker--visits').text(box.visits ?? 0);
								regionEl.find('.map-markers__marker--violations').text(box.violations ?? 0);
							});

							// --- оновлюємо підсумки (totals) під мапою ---
							if (resp.totals) {
								const totals = resp.totals;
								const wrap = $('.home-map__indicators');

								wrap.find('.svg-map-indicators__item--places .svg-map-indicators__value').text(totals.places ?? 0);
								wrap.find('.svg-map-indicators__item--visits .svg-map-indicators__value').text(totals.visits ?? 0);
								wrap.find('.svg-map-indicators__item--violations .svg-map-indicators__value').text(totals.violations ?? 0);
							}

							const hasActiveFilters = formEl.serializeArray().some(({ name, value }) => value && value.trim() !== '');
							$('.filter-action-buttons__btn--reset').prop('disabled', !hasActiveFilters);

							Scripts.__closeFiltersPanel();
						}
					});

				} else if (context === 'region-map') {

					// ID та SLUG регіону з data-атрибутів карти
					const mapEl = $('#map');
					const regionId = parseInt(mapEl.data('region-id') || '0', 10);
					const regionSlug = mapEl.data('region-slug') || '';

					// ---- регіональна Google Map: фільтруємо маркери по AJAX ----
					history.replaceState(null, '', l + '/region/' + regionSlug + '/' + queryStringWithQuestion);

					const ajaxData = {
						action: 'npm_region_markers',
						region_id: regionId,
						filters: filters,
						query_string: queryStringWithQuestion
					};

					$.ajax({
						url: ajaxurl,
						method: 'POST',
						dataType: 'json',
						data: ajaxData,
						success(resp) {
							if (!resp || !resp.success || !Array.isArray(resp.data?.markers)) return;

							// --- оновлюємо маркери на карті через API з googleMapInit() ---
							if (window.__REGION_GMAP__ && typeof window.__REGION_GMAP__.updateMarkers === 'function') {
								window.__REGION_GMAP__.updateMarkers(resp.data.markers);
							}

							// --- оновлюємо індикатори під картою (totals) ---
							(function updateRegionIndicators() {
								// беремо totals із відповіді, або рахуємо з markers, якщо не прийшли
								let totals = resp.data?.totals;
								if (!totals) {
									const markers = resp.data.markers || [];
									let visits = 0, violations = 0;
									for (const m of markers) {
										visits     += Number(m?.visits || 0);
										violations += Number(m?.violations || 0);
									}
									totals = {
										places: markers.length,
										visits,
										violations
									};
								}

								const wrap = $('.region-map__indicators, .region-map-indicators');
								wrap.find('.region-map-indicators__item--places .region-map-indicators__value')
									.text(totals.places ?? 0);
								wrap.find('.region-map-indicators__item--visits .region-map-indicators__value')
									.text(totals.visits ?? 0);
								wrap.find('.region-map-indicators__item--violations .region-map-indicators__value')
									.text(totals.violations ?? 0);
							})();

							// стан кнопки "скинути"
							const hasActiveFilters = formEl.serializeArray().some(({ name, value }) => value && value.trim() !== '');
							$('.filter-action-buttons__btn--reset').prop('disabled', !hasActiveFilters);

							Scripts.__closeFiltersPanel();
						}
					});
				}
			});

			// Обработка сброса формы
			form.on('reset', function () {
				setTimeout(() => {
					// Скинути чекбокси
					form.find('input[type="checkbox"]').prop('checked', false);

					// Для кожного набору радіо-кнопок
					form.find('input[type="radio"][value=""]').each(function () {
						const name = $(this).attr('name');
						// Примусово вибрати радіо з value=""
						form.find(`input[type="radio"][name="${name}"][value=""]`).prop('checked', true);
					});

					// Очистити текстове поле пошуку (.filter-search-block) і сховати хрестик
					const searchInput = form.find('.filter-search-block input[name="search"]');
					if (searchInput.length) {
						searchInput.val('');
						form.find('.filter-search-block__input-reset').removeClass('show');
					}
					
					$(this).trigger('submit');
				}, 0);
			});
		},

		reportsSearchClear() {
			// Наше поле пошуку є лише на сторінці звітів.
			const input = $('.filters-form .filter-search-block input[name="search"]');
			if (!input.length) return;
		 
			const reset = input.closest('.filter-search-block').find('.filter-search-block__input-reset');
		 
			function toggleReset() {
				if (input.val().trim() !== '') {
					reset.addClass('show');
				} else {
					reset.removeClass('show');
				}
			}
		 
			toggleReset();
		 
			input.on('input', toggleReset);
		 
			reset.on('click keydown', function (e) {
				if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					input.val('');
					reset.removeClass('show');
					input.trigger('change');
					input.focus();
				}
			});
		},

		// Отримуємо і виводимо значення на карту при завантаженні сторінки
		svgMapGetStats() {
			var boot = window.__MAP_BOOT__;
			if (!boot || !boot.success || !boot.regions) return;

			var regions = boot.regions;

			$('.map-markers__region').each(function () {
				var region = $(this);
				var slug = region.data('region');
				var box  = regions[slug];
				if (!box) return;

				region.find('.map-markers__marker--places').text(box.places ?? 0);
				region.find('.map-markers__marker--visits').text(box.visits ?? 0);
				region.find('.map-markers__marker--violations').text(box.violations ?? 0);
			});
		},

		regionFilter() {
			const filter 	= $('.region-filter');
			const btn    	= filter.find('.region-filter__btn');
			const dropdown  = filter.find('.region-filter__dropdown');
			const list  	= filter.find('.region-filter__list');
			const item 	 	= filter.find('.region-filter__item');
			const opacitySection = $('.filter-section-opacity');

			const pickedLink  = $('.region-picked-link');
			// const pickedTitle = $('.region-picked-title');

			let selectedBaseUrl = null;

			function openList(){
				dropdown.prop('hidden', false);
				btn.attr('aria-expanded','true');
				opacitySection.addClass('opacity-section');
			}
			function closeList(){
				dropdown.prop('hidden', true);
				btn.attr('aria-expanded','false');
				opacitySection.removeClass('opacity-section');
			}

			// допоміжна: додаємо поточні GET параметри в посилання терма
			function buildUrl(base){
				if (!base) return '#';
				const u   = new URL(base, window.location.origin);
				const cur = new URLSearchParams(window.location.search);
				cur.forEach((val, key) => u.searchParams.append(key, val));
				return u.toString();
			}

			function choose(item){
				const label = $.trim(item.text());
				const slug  = item.data('value');
				selectedBaseUrl = item.data('url') || '#';

				// змінюємо текст кнопки та посилання
				filter.find('.region-filter__label').text(label);
				// pickedTitle.text(label);
				pickedLink.prop('hidden', false);

				closeList();

				// підсвічування області на карті
				$('.ua-map__region[data-region]').removeClass('is-active');
				$('.ua-map__region[data-region="'+slug+'"]').addClass('is-active');

				// відображення маркерів по області
				$('.map-markers__region[data-region]').removeClass('is-active');
				$('.map-markers__region[data-region="'+slug+'"]').addClass('is-active');
			}

			// відкрити/закрити список
			btn.on('click', function(e){
				e.preventDefault();
				const expanded = btn.attr('aria-expanded') === 'true';
				expanded ? closeList() : openList();
			});

			// вибір області
			list.on('click', '.region-filter__item', function(e){
				e.preventDefault();
				choose($(this));
			});

			// клік поза списком — закрити
			$(document).on('click', function(e){
				const isOpen = btn.attr('aria-expanded') === 'true' && dropdown.prop('hidden') === false;
				if (isOpen && !filter[0].contains(e.target)) closeList();
			});

			// перед переходом завжди перезбираємо href
			pickedLink.on('click', function(e){
				if (!selectedBaseUrl) return;
				const fresh = buildUrl(selectedBaseUrl);
				$(this).attr('href', fresh);
			});
		},

		filtersSearchBlock() {
			const searchInput = $('#filter-search');
			if (!searchInput.length) return;
			const resultsBox = $('.filter-search-results');

			function updateInputHighlight() {
				const hasText = searchInput.val().trim() !== '';
				searchInput.toggleClass('not-empty', hasText);
			}

			function performLiveSearch(query) {
				if (query.length < 2) {
					resultsBox.empty();
					resultsBox.removeClass('has-results');
					return;
				}

				$.ajax({
					url: ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'live_search_places',
						search: query
					},
					success: function(response) {
						if (response.success && response.data.length > 0) {
							const resultsHtml = response.data.map(item => `
								<a href="${item.link}" class="search-result-item">
									${item.title}
									<svg aria-hidden="true" class="icon">
										<use href="${localizeTexts.spritePath}#arrow"></use>
									</svg>
								</a>
							`).join('');
							resultsBox.html(resultsHtml);
							resultsBox.addClass('has-results');
						} else {
							resultsBox.html('<div class="no-results">' + localizeTexts.noResults + '</div>');
							resultsBox.addClass('has-results');
						}
					}
				});
			}

			const debouncedSearch = Scripts.debounce(function () {
				const query = searchInput.val().trim();
				performLiveSearch(query);
				updateInputHighlight();
			}, 300);

			searchInput.on('input', debouncedSearch);

			searchInput.on('keydown', function(e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					performLiveSearch(searchInput.val().trim());
					updateInputHighlight();
				}
			});

			$('.filter-search-block__input-reset').on('click', function () {
				resultsBox.empty();
				resultsBox.removeClass('has-results');
				updateInputHighlight();
			});
		},

		timeline() {
			const progress = $('.about-us-timeline__progress');
			const fill = $('.about-us-timeline__progress-fill');
			const items = $('.timeline-item');

			if (!progress.length || !fill.length || !items.length) return;

			function updateTimeline() {
				const winTop = $(window).scrollTop();
				const winCenter = winTop + window.innerHeight / 2;

				const progTop = progress.offset().top;
				const progHeight = progress.outerHeight();
				const progBottom = progTop + progHeight;

				let newHeight = 0;

				if (winCenter < progTop) {
					newHeight = 0;
				} else if (winCenter > progBottom) {
					newHeight = progHeight;
				} else {
					newHeight = winCenter - progTop;
				}

				fill.css('height', newHeight + 'px');

				// is-active по верхушке контента (без padding)
				items.each(function () {
					const item = $(this);
					const rect = this.getBoundingClientRect();
					const paddingTop = parseFloat(item.css('padding-top')) || 0;
					const contentTop = rect.top + paddingTop;

					if (contentTop < window.innerHeight / 2) {
						item.addClass('is-active');
					} else {
						item.removeClass('is-active');
					}
				});
			}

			updateTimeline();
			$(window).on('scroll resize', updateTimeline);
		},

		accordionScripts() {
			let btn = $('.accordion-trigger');
			let panel = $('.accordion-panel');

			btn.click(function(){
				if ($(this).attr('aria-expanded') === 'true') {
					$(this).attr('aria-expanded', 'false');
					$(this).next().attr('aria-hidden', 'true').slideUp(250);
				} else {
					btn.attr('aria-expanded', 'false');
					panel.attr('aria-hidden', 'true').slideUp(250);
					$(this).attr('aria-expanded', 'true');
					$(this).next().attr('aria-hidden', 'false').slideDown(250);
				}
			});
		},

		teamScripts() {
			let tabBtn = $('.tab-btn');
			let content = $('.tab-content');

			tabBtn.click(function(){
				if (!$(this).hasClass('active')) {
					tabBtn.removeClass('active');
					content.removeClass('active');
					$(this).addClass('active');
					$(".tab-content[data-tab='" + $(this).data('tab') +"']").addClass('active');

					// Закриваємо всі акордеони при перемиканні вкладки
					$('.structure-accordion-item__btn').attr('aria-expanded', 'false');
					$('.structure-accordion-item__content').attr('aria-hidden', 'true').slideUp(0);
				}
			});

			let accBtn = $('.structure-accordion-item__btn');
			let panel = $('.structure-accordion-item__content');

			accBtn.click(function(){
				if ($(this).attr('aria-expanded') === 'true') {
					$(this).attr('aria-expanded', 'false');
					$(this).next().attr('aria-hidden', 'true').slideUp(250);
				} else {
					$(this).attr('aria-expanded', 'true');
					$(this).next().attr('aria-hidden', 'false').slideDown(250);
				}
			});
		},

		bmForm() {
			const ctrl = this;

			const popup = $('#bm-form-popup');
			const popupOverlay  = popup.find('.bm-form-popup__overlay');
			const popupContent = popup.find('.bm-form-popup__content');
			const popupBody = $('#bm-form-popup-body');
			const popupSuccess = $('#bm-form-popup-success');
			const openBtn = $('#bm-form-btn');
			const closeBtn = popup.find('.bm-form-popup__close');

			function openPopup() {
				popup.removeAttr('hidden');
				openBtn.attr('aria-expanded', 'true');

				lockScroll();
			}

			function closePopup() {
				popup.attr('hidden', true);
				openBtn.attr('aria-expanded', 'false').focus();
				popupBody.show();
				popupSuccess.addClass('hide');

				unlockScroll();
			}

			openBtn.on('click', openPopup);
			closeBtn.on('click', closePopup);
			
			popupOverlay.on('click', function(e) {
				if ($(e.target).is(popupOverlay)) {
					closePopup();
				}
			});

			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && !popup.is('[hidden]')) {
					closePopup();
				}
			});

			$(".wpcf7-form").on("input", ".wpcf7-not-valid", function() {
				$(this).removeClass( "wpcf7-not-valid" );
			});

			$('.bm-form').on('wpcf7mailsent', function (event) {
				popupBody.hide();
				popupSuccess.removeClass('hide');
			});

			function lockScroll() {
				const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
				ctrl.body.css({
					overflow: 'hidden',
					'padding-right': scrollBarWidth + 'px'
				});
			}

			function unlockScroll() {
				ctrl.body.css({
					overflow: '',
					'padding-right': ''
				});
			}
		},

		clipboard() {
			let copyBlock = $('.copy-btn');

			copyBlock.each(function() {
				$(this).click(function(){
					let text = $(this).data('copy-text');
					let icon = $(this).find('.copy-btn__icon');
					let iconWidth = icon.innerWidth();
					navigator.clipboard.writeText(text);

					if ($('.clipboard-popup').length) {
						$('.clipboard-popup').remove()
					}

					let popup = $('<div/>').appendTo('#page');
					popup.attr('class', 'clipboard-popup').attr('aria-live', 'polite').text($(this).data('popup-text'));

					popup.addClass('active');
					
					let position = icon.offset();
					let popupWidth = popup.innerWidth();
					let popupHeight = popup.innerHeight();

					let top = position.top - popupHeight - 10;
					let iconCenter = position.left + iconWidth / 2;
					let left = iconCenter - popupWidth / 2;

					if (left < 0) left = 0;

					popup.css({
						'position': 'absolute',
						'top': top + 'px',
						'left': left + 'px'
					});

					setTimeout(function () {
						popup.removeClass('active').removeAttr('style');
						popup.remove();
					}, 2000);
				});

			});
		},

		contentSlider: function() {
			const blockSliders = document.getElementsByClassName('block-content-slider');
			for (let blockSlider of blockSliders) {
				const slider = blockSlider.getElementsByClassName('content-slider')[0];
				const nextEl = blockSlider.getElementsByClassName('block-content-slider-button-next')[0];
				const prevEl = blockSlider.getElementsByClassName('block-content-slider-button-prev')[0];
				const paginate = blockSlider.getElementsByClassName('block-content-slider-pagination')[0];
				let swiper = new Swiper(slider, {
					loop: true,
					pagination: {
						el: paginate,
						type: "fraction",
						formatFractionCurrent: function (number) {
							return number;
						},
						formatFractionTotal: function (number) {
							return number;
						},
						renderFraction: function (currentClass, totalClass) {
							return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`;
						}
					},
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					},
					speed: 700,
					effect: "creative",
					creativeEffect: {
						prev: {
							shadow: true,
							translate: ["-20%", 0, -1],
						},
							next: {
							translate: ["100%", 0, 0],
						},
					}
				});
			}
		},

		violationsToggle() {
			let moreText = (typeof localizeTexts !== 'undefined' && localizeTexts.more) ? localizeTexts.more : 'Детальніше';
			let lessText = (typeof localizeTexts !== 'undefined' && localizeTexts.less) ? localizeTexts.less : 'Згорнути';

			$('.visit-violations__item').each(function() {
				let item = $(this);
				if (item.data('clampReady')) return;
				item.data('clampReady', true);

				let text   = item.find('.visit-violations__text');
				let toggle = item.find('.visit-violations__toggle');
				let btn    = toggle.find('.visit-violations__toggle-btn');
				let textEl = btn.find('.visit-violations__toggle-text');
				let signEl = btn.find('.visit-violations__toggle-sign');

				function evaluate() {
					if (item.data('expanded')) {
						toggle.prop('hidden', false);
						return;
					}
					text.addClass('is-collapsed');
					let el = text.get(0);
					let overflowing = el.scrollHeight > el.clientHeight + 1;
					toggle.prop('hidden', !overflowing);
					if (!overflowing) {
						text.removeClass('is-collapsed');
					}
				}

				btn.on('click', function() {
					let expanded = !item.data('expanded');
					item.data('expanded', expanded);
					text.toggleClass('is-collapsed', !expanded);
					textEl.text(expanded ? lessText : moreText);
					signEl.text(expanded ? '−' : '+');
					btn.attr('aria-expanded', expanded);
				});

				evaluate();
				item.data('evaluate', evaluate);
			});

			let resizeTimer;
			$(window).off('resize.violations').on('resize.violations', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					$('.visit-violations__item').each(function() {
						let fn = $(this).data('evaluate');
						if (fn) fn();
					});
				}, 150);
			});
		},

		loadmoreVisits() {
			const section = $('#visitsSection');
			const wrap    = $('#visitsWrap');
			const btnBox  = $('.visits-loadmore');
			const btn     = $('#visitsMoreBtn');

			if (!section.length || !wrap.length || !btn.length) return;

			const placeId  = parseInt(section.data('place-id'), 10) || 0;
			let   offset   = parseInt(section.data('offset'), 10)    || 1;
			const total    = parseInt(section.data('total'), 10)     || 1;
			const nonce    = section.data('nonce') || '';

			const btnDefaultHtml = btn.html();

			btn.on('click', function(e){
				e.preventDefault();
				if (offset >= total) { btnBox.remove(); return; }

				btn.prop('disabled', true).text(localizeTexts.loadmore);

				$.ajax({
					url: ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						action:   'npm_visits_next',
						place_id: placeId,
						offset:   offset,
						nonce:    nonce
					}
				})
				.done(function(res){
					if (!res || !res.success || !res.data) throw new Error('Bad response');

					if (res.data.html) {
						wrap.append(res.data.html);
						Scripts.galleryLightbox();
						Scripts.violationsToggle();
					}

					offset = (typeof res.data.next_offset !== 'undefined') ? res.data.next_offset : (offset + 1);
					section.data('offset', offset);

					if (!res.data.has_more || offset >= total) {
						btnBox.remove(); // видаляємо кнопку та її контейнер
					} else {
						btn.prop('disabled', false).html(btnDefaultHtml);
					}
				})
				.fail(function(){
					btn.prop('disabled', false).html(btnDefaultHtml);
				});
			});

		},

		galleryLightbox() {
			baguetteBox.run('.visit-gallery');
		},

		init() {
			this.varInit();
			this.debounce();
			this.scrollToAnchor();
			this.headerScripts();
			this.searchReset();
			
			this.googleMapInit();

			if ($('.filters-section').length) {
				this.filtersToggle();
				this.filtersDropdownToggle();
				this.filtersSearchInput();
				this.initDateRangePickerAir();
				this.initFilterStateTracking();
				this.initFilterAjaxHandling();
				this.reportsSearchClear();
			}

			if ($('#home-map').length) {
				this.lazyInitSvgMap();
				this.svgMapGetStats();
				this.regionFilter();
			}

			if ($('.filter-search-block').length) {
				this.filtersSearchBlock();
			}

			if ($('.page-template-page-about-us').length) {
				this.timeline();
			}

			this.accordionScripts();

			if ($('.page-template-page-structure').length) {
				this.teamScripts();
			}

			if ($('.bm-form').length) {
				this.bmForm();
			}

			if ($('.copy-btn').length) {
				this.clipboard();
			}

			if ($('.content-slider').length) {
				this.contentSlider();
			}

			if ($('.single-places-of-detention').length) {
				this.violationsToggle();
				this.loadmoreVisits();
				this.galleryLightbox();
			}
			
		},
	};

	$(document).ready(function () {
		Scripts.init();
	});
});